import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, Outlet, useLocation, Navigate } from "react-router-dom";

const ADMIN_LINKS = [
  { label: "Dashboard", path: "/admin/dashboard" },
  { label: "Sources", path: "/admin/sources" },
  { label: "Payees", path: "/admin/payees" },
  { label: "Groups", path: "/admin/groups" },
  { label: "Categories", path: "/admin/categories" },
  { label: "Expense Types", path: "/admin/expense-types" },
  { label: "Invoices", path: "/admin/invoices" },
  { label: "Auto Transactions", path: "/admin/auto-transactions" },
  { label: "Library", path: "/admin/library" },
  { label: "Imports", path: "/admin/imports" },
  { label: "Attachments", path: "/admin/attachments" },
  { label: "LLM Chat (Gemma 4)", path: "/admin/llm-chat" },
  { label: "Debug Console", path: "/admin/debug" },
];

export const AdminIndexRedirect = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    return null;
  }
  return <Navigate to="/admin/dashboard" replace />;
};

export const AdminPage = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // On mobile, if we are at the root, show the menu.
  // Otherwise show the content (Outlet).
  if (isMobile) {
    if (location.pathname === "/admin") {
      return (
        <Box sx={{ flexGrow: 1, p: 2 }}>
          <Typography variant="h4" gutterBottom>
            Administration
          </Typography>
          <List component="nav">
            {ADMIN_LINKS.map((link) => (
              <ListItem key={link.path} disablePadding>
                <ListItemButton component={Link} to={link.path}>
                  <ListItemText primary={link.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      );
    }

    return (
      <Box sx={{ flexGrow: 1, p: 2 }}>
        <Outlet />
      </Box>
    );
  }

  // Desktop layout: Sidebar + Content
  return (
    <Box sx={{ flexGrow: 1, p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Administration
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 3 }}>
          <List component="nav">
            {ADMIN_LINKS.map((link) => (
              <ListItem key={link.path} disablePadding>
                <ListItemButton
                  component={Link}
                  to={link.path}
                  selected={
                    location.pathname === link.path ||
                    (link.path !== "/admin" &&
                      location.pathname.startsWith(link.path))
                  }
                >
                  <ListItemText primary={link.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Grid>
        <Grid size={{ xs: 12, md: 9 }}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
  );
};
